// Exact copy of app/title.component.ts except import UserService from shared
import { Component, OnInit, ViewChildren, ElementRef, Renderer2, AfterViewInit, QueryList } from '@angular/core';
import { RouterLink, Router, NavigationExtras } from '@angular/router';
import { HttpService } from '../../../../core/services/http.service';

@Component({
    selector: 'app-top-nav',
    templateUrl: './topNav.component.html',
    styleUrls: ['./topNav.component.css']
})

export class TopNavComponent implements OnInit {
    allMenu: Object[] = [];
    arrMenu: Array<object>;

    constructor(
        private http: HttpService,
        private router: Router,
        private elementRef: ElementRef,
        private render: Renderer2
    ) {

    }

    ngOnInit() {
        const pathname = window.location.pathname;
        let curParentIds = [];
        this.http.get('api/getMenuList', {}).subscribe(data => {
            console.log(data, 'data');

            this.allMenu = data['body'] || [];
            const menusForIsShow = this.allMenu.filter(item => item['isShow'] === '1');

            // 转为tree
            const arrMenuArr = [];
            menusForIsShow.forEach(item => {

                // 当前菜单
                if (item['href'] === pathname) {
                    item['selected'] = true;
                    curParentIds = item['parentIds'].split(',');
                }

                if (item['parentId'] === '1') {
                    arrMenuArr.push({
                        id: item['id'],
                        parentId: '1',
                        name: item['name'],
                        menuList: []
                    });
                }
            });

            arrMenuArr.forEach(value => {
                menusForIsShow.forEach(item => {
                    if (value['id'] === item['parentId']) {
                        // 当前菜单高亮
                        if (curParentIds.indexOf(item['id']) !== -1) {
                            item['selected'] = true;
                        }
                        // 获得一级菜单
                        item['subMenus'] = [];
                        value['menuList'].push(item);

                        // 获得二级菜单
                        menusForIsShow.forEach(val => {
                            if (item['id'] === val['parentId']) {
                                if (val['href'] === pathname) {
                                    val['selected'] = true;
                                }
                                item['subMenus'].push(val);
                            }
                        });
                    }
                });
            });

            this.arrMenu = arrMenuArr;
            // console.log(this.arrMenu);

        });
    }

    handleLeftNav() {
        // $(document.body).toggleClass('closing');
    }

    navClick(item, event) {
        event.preventDefault();

        this.router.navigate([item.href || ''], {
            queryParams: { 'date': new Date().getTime() }
        });
    }
}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/components/system/topNav/topNav.component.ts